// @flow
import React from 'react';
import {
  CLUSTER_TABLEFLOW_MONTHLY_INPUTS_JSON_CONFIG,
  CLUSTER_TABLEFLOW_V2_MONTHLY_INPUTS_JSON_CONFIG,
  TABLEFLOW_V2_KAFKA_THROUGHPUT_TOOLTIP_TEXT,
  TABLEFLOW_VERSIONS,
} from '@src/constants';

import { Tooltip } from '../../presentational/Tooltip';

import { getIfConfluentStorageIsEnabledFromFormikValues } from './utils';

// One row set per version; exactly one ever reaches the UI. Units live in displayName.
export const TABLEFLOW_ROWS_CONFIG_BY_VERSION = {
  [TABLEFLOW_VERSIONS.LEGACY]: [
    {
      backendName: 'is_enabled',
      displayName: 'Active',
      isBooleanField: true,
    },
    {
      backendName: 'num_topics',
      displayName: 'Number of Topics',
    },
    {
      backendName: 'avg_throughput_mbps',
      displayName: 'Average Throughput (MBps)',
    },
  ],
  [TABLEFLOW_VERSIONS.V2]: [
    {
      backendName: 'is_enabled',
      displayName: 'Active',
      isBooleanField: true,
    },
    {
      backendName: 'num_topics',
      displayName: 'Number of Topics',
    },
    {
      backendName: 'data_processed_gb',
      displayName: 'GB Processed – Table Data',
    },
    {
      backendName: 'index_data_processed_gb',
      displayName: 'GB Processed – Table Index',
    },
    {
      backendName: 'avg_throughput_mbps',
      displayName: (
        <>
          Tableflow Kafka Throughput (MBps)
          <Tooltip text={TABLEFLOW_V2_KAFKA_THROUGHPUT_TOOLTIP_TEXT} />
        </>
      ),
      displayNameForDownloads: 'Tableflow Kafka Throughput (MBps)',
    },
    {
      backendName: 'storage_gb',
      displayName: 'Tableflow Storage (GB)',
      showOrHideFunc: (values) =>
        getIfConfluentStorageIsEnabledFromFormikValues(values, TABLEFLOW_VERSIONS.V2),
    },
  ],
};

// Sibling objects, not extra keys -- the backend 400s on the wrong one.
// storage_gb is a user input on V2 (CCE-2593), shown only under Confluent-managed storage.
// Also the Formik key per version -- each version's component reads/writes its own key end to
// end, so there's no longer a separate "wire key" concept.
export const TABLEFLOW_WIRE_KEY_BY_VERSION = {
  [TABLEFLOW_VERSIONS.LEGACY]: CLUSTER_TABLEFLOW_MONTHLY_INPUTS_JSON_CONFIG,
  [TABLEFLOW_VERSIONS.V2]: CLUSTER_TABLEFLOW_V2_MONTHLY_INPUTS_JSON_CONFIG,
};

// The response should hold the estimate's version, but fall back to the sibling key so a
// rollout gap degrades to a usable form instead of an empty, unsavable one.
export const getTableflowInputsFromCluster = (cluster, tableflowVersion) =>
  cluster?.[TABLEFLOW_WIRE_KEY_BY_VERSION[tableflowVersion]] ??
  cluster?.[CLUSTER_TABLEFLOW_MONTHLY_INPUTS_JSON_CONFIG] ??
  cluster?.[CLUSTER_TABLEFLOW_V2_MONTHLY_INPUTS_JSON_CONFIG] ??
  {};
